import type { Editor } from '@tiptap/react';
import { MediaUploadButton } from './MediaUploadButton';

interface ImageUploadButtonProps {
  editor: Editor;
  snippetId: string;
}

export function ImageUploadButton({ editor, snippetId }: ImageUploadButtonProps) {
  return <MediaUploadButton editor={editor} snippetId={snippetId} variant="image" />;
}
